import { ReduxListener } from '../../types';

import taskListeners from './tasks';
import dataListeners from './data';

const setupListeners = (startListening: ReduxListener) =>
  [taskListeners, dataListeners].forEach(listener => listener(startListening));

export default setupListeners;
